import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { Capacitor } from "@capacitor/core";

import { AppModule } from "./app/app.module";
import { environment } from "src/environments/environment";

import * as Sentry from "@sentry/angular";

import { BUILD, VERSION, DATE } from "src/autogenerated-version";
import { beforeSend } from "@app/sentry/before-send";

// Sentry only runs in the production environment, and never on the local dev
// server (`npm run serve` builds with the production config but is served from
// localhost). This keeps DEV/staging noise (e.g. Angular's "running in
// development mode" message) out of Sentry.
if (
  environment.NAME === "PROD" &&
  !window.location.hostname.includes("localhost")
) {
  sentryInit();
} else {
  console.log(`Sentry disabled (environment: ${environment.NAME})`);
}
// Disable console logs in production

//printHola();
//disableLogsOnProduction();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

// @ionic/pwa-elements (~228 KB) is only needed for @capacitor/camera on the
// web. It is useless on native iOS/Android, so we lazy-load it (and only on
// web) instead of shipping it in the initial bundle.
if (!Capacitor.isNativePlatform()) {
  import("@ionic/pwa-elements/loader").then(({ defineCustomElements }) =>
    defineCustomElements(window)
  );
}

function disableLogsOnProduction() {
  if (environment.NAME === "PROD") {
    window.console.log = () => {};
    window.console.warn = () => {};
    window.console.error = () => {};
  }
}

function sentryInit() {
  Sentry.init({
    dsn: "https://f56e9185eaa01b5a651ca0ee609ff41e@o186379.ingest.us.sentry.io/4508834206187520",
    sendDefaultPii: true,
    environment: environment.NAME,
    beforeSend,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Only forward real warnings/errors to Sentry. Capturing console.log/info
      // floods Sentry with debug noise (and can leak PII, since sendDefaultPii
      // is on and objects get serialized into the event).
      Sentry.captureConsoleIntegration({ levels: ["warn", "error"] }),
    ],
    tracesSampleRate: 0,
    release: `${VERSION}(${BUILD}-${DATE})`,
    dist: `${BUILD}-${DATE}`,
  });
}
